export default __webpack_public_path__ + "static/media/wind.0e1a1629.svg";